module.exports = __webpack_public_path__ + "assets/1193757e9242daf8f9b8f05a2ca9021e.svg";


//////////////////
// WEBPACK FOOTER
// ./app/orders/assets/orders.svg
// module id = 716
// module chunks = 0